<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.studentName" placeholder="学生姓名" clearable></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.phone" placeholder="家长手机" clearable></el-input>
                    </div>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1; getData()">查询</el-button>
                </div>
            </div>

            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="550"
                border
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255,255,0.7)"
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="studentName" label="学生姓名" min-width="110" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="className" label="班级名称" min-width="140" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="phone" label="家长手机" min-width="120" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="type" label="留言类型" width="90">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">文本</span>
                        <span v-else-if="scope.row.type == 2">语音</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="留言内容" min-width="220" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">{{ scope.row.content }}</span>
                        <span v-else-if="scope.row.type == 2">
                            <el-link type="primary" :underline="false" @click="openAudio(scope.row.audioPath)">
                                点击查看留言
                            </el-link>
                        </span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="direction" label="留言方向" width="140">
                    <template slot-scope="scope">
                        <span v-if="scope.row.direction == 1">家长向学生留言</span>
                        <span v-else-if="scope.row.direction == 2">学生向家长留言</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createAt" label="留言时间" width="160">
                    <template slot-scope="scope">
                        {{ formatTime(scope.row.createAt) }}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="80px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button style="color: red" @click.native.prevent="del(scope.row)" type="text" size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="播放语音" :visible.sync="audioVisible" width="520px" :close-on-click-modal="false" @close="closeAudio">
            <audio v-if="audioPath" ref="audioPlayer" :src="audioPath" controls style="width: 100%;"></audio>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="audioVisible=false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../common/http';

    export default {
        name: "PlatformMessage",
        data(){
            return{
                loading:false,
                loadingText:"",
                menuName:"",
                depts:[],
                data:[],
                form:{
                    deptId:"",
                    studentName:"",
                    phone:"",
                    id:""
                },
                common:{
                    total:0,
                    pageSize:30,
                    page:1,
                    isPage:1,
                    allSizes:[30,50,100],
                },
                audioVisible:false,
                audioPath:"",
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                let url  = this.listDeptUrl;
                let data = { parentId:"0" };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts = res.data.list || [];
                        if(this.depts.length > 0){
                            this.form.deptId = this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading = true;
                this.loadingText = "数据加载中...";
                let url  = this.platformMessageListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    studentName:this.form.studentName,
                    phone:this.form.phone
                };
                this.apiPost(url,data).then((res) => {
                    this.loading = false;
                    if(res.status==200){
                        this.data = res.data.list || res.data.data || [];
                        this.common.total = res.data.total || 0;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.loading = false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            del(row){
                this.form.id = row.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.platformMessageRemoveUrl;
                let data = { id: this.form.id };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            openAudio(path){
                if(this.$util.isEmpty(path)){
                    this.$commonFn.showTip("语音地址为空",2);
                    return;
                }
                this.audioPath = path;
                this.audioVisible = true;
                this.$nextTick(() => {
                    if(this.$refs.audioPlayer && this.$refs.audioPlayer.play){
                        try{ this.$refs.audioPlayer.play(); }catch(e){}
                    }
                });
            },
            closeAudio(){
                if(this.$refs.audioPlayer && this.$refs.audioPlayer.pause){
                    try{ this.$refs.audioPlayer.pause(); }catch(e){}
                }
                this.audioPath = "";
            },
            formatTime(ts){
                if(ts === null || ts === undefined || ts === ''){
                    return '';
                }
                let t = ts;
                // 兼容后端返回秒/毫秒时间戳 & 字符串数字
                if(typeof t === 'string' && /^\d+$/.test(t)){
                    t = parseInt(t, 10);
                }
                if(typeof t === 'number' && t < 1000000000000){
                    t = t * 1000;
                }
                let d = new Date(t);
                if(isNaN(d.getTime())){
                    return ts;
                }
                let pad = (n) => (n < 10 ? ('0'+n) : ''+n);
                return d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
    .table{
        width: 100%;
        font-size: 14px;
    }
</style>




// WEBPACK FOOTER //
// src/components/page/hsc/PlatformMessage.vue